import Model from '../../ModelBinding/Model';
import RateScoreCollection from './RateScoreCollection';
import RateSuggestion from '../RateSuggestion/RateSuggestion';
import RateCriterion from '../RateCriterion/RateCriterion';

export default class RateScore extends Model {
  public score?: number;
  public criterion?: RateCriterion;
  public suggestion?: RateSuggestion;
  public over_expectation?: Boolean;

  bind() {
    this.score = this.getIntAttribute('score');
    this.criterion = this.getRelation('criterion', RateCriterion) as RateCriterion;
    this.suggestion = this.getRelation('suggestion', RateSuggestion) as RateSuggestion;
    this.over_expectation = this.getBooleanAttribute('over_expectation');
  }

  static getCollection() {
    return RateScoreCollection;
  }
}
